/**
 * Power Kitchen LP — Hero countdown timer.
 * Counts down to the next intake deadline (Monday, 10am America/Toronto).
 * Requires Luxon (loaded globally in layout/theme.no-header-footer.liquid).
 */
document.addEventListener('DOMContentLoaded', function () {
  var TIMEZONE = 'America/Toronto';
  var INTAKE_HOUR = 10;
  var DEFAULT_CLOSED_TEXT = 'Applications closed. The next intake opens Monday.';

  var countdownEls = document.querySelectorAll('[data-lp-countdown]');
  if (!countdownEls.length) {
    return;
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function getNextIntakeDeadline(now) {
    var daysUntilMonday = (8 - now.weekday) % 7;
    var deadline = now.plus({ days: daysUntilMonday }).set({
      hour: INTAKE_HOUR,
      minute: 0,
      second: 0,
      millisecond: 0,
    });

    if (deadline <= now) {
      deadline = deadline.plus({ weeks: 1 });
    }

    return deadline;
  }

  function renderTimer(countdownEl, deadline, now) {
    var diff = deadline.diff(now, ['hours', 'minutes', 'seconds']).toObject();
    var hoursEl = countdownEl.querySelector('[data-lp-countdown-hours]');
    var minutesEl = countdownEl.querySelector('[data-lp-countdown-minutes]');
    var secondsEl = countdownEl.querySelector('[data-lp-countdown-seconds]');

    if (hoursEl) {
      hoursEl.textContent = pad(Math.floor(diff.hours || 0));
    }
    if (minutesEl) {
      minutesEl.textContent = pad(Math.floor(diff.minutes || 0));
    }
    if (secondsEl) {
      secondsEl.textContent = pad(Math.floor(diff.seconds || 0));
    }
  }

  function closeTimer(countdownEl) {
    var timerBlock = countdownEl.querySelector('[data-lp-countdown-timer]');
    var closedMessageEl = countdownEl.querySelector('[data-lp-countdown-closed]');

    if (timerBlock) {
      timerBlock.hidden = true;
    }
    if (closedMessageEl) {
      closedMessageEl.textContent = countdownEl.dataset.lpCountdownClosedText || DEFAULT_CLOSED_TEXT;
      closedMessageEl.hidden = false;
    }
  }

  function initCountdown(countdownEl) {
    var deadline = getNextIntakeDeadline(luxon.DateTime.now().setZone(TIMEZONE));

    var intervalId = setInterval(function () {
      try {
        var now = luxon.DateTime.now().setZone(TIMEZONE);

        if (deadline <= now) {
          clearInterval(intervalId);
          closeTimer(countdownEl);
          return;
        }

        renderTimer(countdownEl, deadline, now);
      } catch (error) {
        clearInterval(intervalId);
        // eslint-disable-next-line no-console
        console.error('lp-power-kitchen-hero: countdown tick failed', error);
        closeTimer(countdownEl);
      }
    }, 1000);

    renderTimer(countdownEl, deadline, luxon.DateTime.now().setZone(TIMEZONE));
  }

  try {
    if (typeof luxon === 'undefined') {
      throw new Error('Luxon library is not available');
    }

    countdownEls.forEach(function (countdownEl) {
      initCountdown(countdownEl);
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('lp-power-kitchen-hero: countdown init failed', error);
    countdownEls.forEach(closeTimer);
  }
});
